

export const ROUTES = {
  home: {
    root: '/',
  },
  contact: {
    root: '/contacto',
  },
  aboutUs: {
    root: '/nosotros',
  },
  workWithUs: {
    root: '/trabaja-con-nosotros',
  },
  literature: {
    root: '/literatura',
    categories: (categorySlug: string) => `/literatura/${categorySlug}`,
    details: (categorySlug: string, literatureSlug: string) => `/literatura/${categorySlug}/${literatureSlug}`,
  },
  usedEquipmentsCertificate: {
    root: '/equipos-usados-certificados'
  },
  promotions: {
    root: '/promociones',
    details: (slug: string) => `/promociones/${slug}`
  },
  industries: {
    root: '/industrias',
    details: (slug: string) => `/industrias/${slug}`,
  },
  usedEquipments: {
    root: '/equipos-usados',
    categories: '/equipos-usados/categorias',
    inventory: '/equipos-usados/inventario',
    details: (slug: string) => `/equipos-usados/categorias/${slug}`,
    used: (slug: string, slugDetail: string) => `/equipos-usados/categorias/${slug}/${slugDetail}`
  },
  rentals: {
    root: '/rentas',
    categories: (slug: string) => `/rentas/${slug}`
  },
  technologySolutions: {
    root: '/soluciones-tecnologicas',
    details: (slug: string) => `/soluciones-tecnologicas/${slug}`,
    miningTechnology: 'tecnologia-para-mineria',
    industrialWirelessNetworks: 'redes-inalambricas-industriales',
    static:{
      catMinestarTechnicalSupport: 'soporte-tecnico-cat-minestar',
      catMinestarConsulting: 'consultoria-cat-minestar',
      catMinestarTraining: 'capacitaciones-cat-minestar',
      catCard: 'cuenta-comercial-cat',
      technicalSupport: 'soporte-tecnico',
      consulting: 'servicios-de-consultorias',
      training: 'capacitaciones-y-entrenamientos',
    }
  },
  partsServices: {
    root: '/refacciones-y-servicios',
    details: (slug: string) => `/refacciones-y-servicios/${slug}`
  },
  partsServicesSubcategories: {
    details: (slugCategory: string, slugSubcategory: string) => `/refacciones-y-servicios/${slugCategory}/${slugSubcategory}`,
    visionLink: '/refacciones-y-servicios/soluciones-digitales-cat/visionlink/',
    sis2go: '/refacciones-y-servicios/soluciones-digitales-cat/cat-sis2go/',
    catApp: '/refacciones-y-servicios/soluciones-digitales-cat/cat-central-app/',
    static:{
      digitalSolutions: 'soluciones-digitales-cat',
      originalParts: 'refacciones',
      catCentral:'cat-central-app',
      sis2go: 'cat-sis2go',
      codigoQRCat: 'codigos-qr-cat',
      visionLink: 'visionlink',
    }
  },
  tires: {
    root: '/llantas',
    industries: (industrySlug: string) => `/llantas/${industrySlug}`,
    details: (industrySlug: string, tireSlug: string) => `/llantas/${industrySlug}/${tireSlug}`
  },
  products: {
    root: '/productos-nuevos',
     brand: (brandSlug: string | undefined) => `/productos-por-marca/${brandSlug}`,
    industry: (industrySlug: string | undefined) => `/productos-nuevos/${industrySlug}`,
    family: (industrySlug: string | undefined, familySlug: string | undefined) => `/productos-nuevos/${industrySlug}/${familySlug}`,
    subfamily: (industrySlug: string | undefined, familySlug: string | undefined, subfamilySlug: string | undefined) => `/productos-nuevos/${industrySlug}/${familySlug}/${subfamilySlug}`,
    brands: (industrySlug: string | undefined, familySlug: string | undefined, subfamilySlug: string | undefined, brand: string | undefined) => `/productos-nuevos/${industrySlug}/${familySlug}/${subfamilySlug}/?brand=${brand}`,
    productDetails: (productSlug: string, industrySlug: string | undefined) => !industrySlug ? `/producto-nuevo/${productSlug}` : `/producto-nuevo/${productSlug}/?industria=${industrySlug}`,
  },
  news: {
    root: '/noticias',
    categories: (categorySlug: string) => `/noticias/${categorySlug}`,
    details: (categorySlug: string, newsSlug: string) => `/noticias/${categorySlug}/${newsSlug}`,
  },
  brands: {
    root: '/productos-por-marca',
    brand: (brandSlug: string | undefined) => `/productos-por-marca/${brandSlug}`,
    industry: (brandSlug: string | undefined, industrySlug: string | undefined) => `/productos-por-marca/${brandSlug}/${industrySlug}`,
    family: (brandSlug: string | undefined, industrySlug: string | undefined, familySlug: string | undefined) => `/productos-por-marca/${brandSlug}/${industrySlug}/${familySlug}`,
    subfamily: (brandSlug: string | undefined, industrySlug: string | undefined, familySlug: string | undefined, subfamilySlug: string | undefined) => `/productos-por-marca/${brandSlug}/${industrySlug}/${familySlug}/${subfamilySlug}`
  },
  branches: {
    root: '/sucursales',
    branch: (typeSlug: string, branchSlug: string) => `/sucursales/${typeSlug}/${branchSlug}`,
    googleHowToGo:  (latitude: number, length: number) => `https://www.google.com/maps?q=${latitude},${length}`, 
    google: (latitude: number, length: number) => `https://www.google.com/maps?q=${latitude},${length}&hl=es;z=14&output=embed`,
  },
  solutions:{
    root: '/soluciones',
    addedValueCat: {
      root: '/soluciones/valor-agregado-cat',
      digitalTools:{
        root: '/soluciones/valor-agregado-cat/herramientas-digitales',
        catCentralApp: '/soluciones/valor-agregado-cat/herramientas-digitales/cat-central-app',
        partsCatCom: '/soluciones/valor-agregado-cat/herramientas-digitales/parts-cat-com',
        sis2go: '/soluciones/valor-agregado-cat/herramientas-digitales/cat-sis2go',
        visionLink: '/soluciones/valor-agregado-cat/herramientas-digitales/visionlink',
      },
      serviceAndSupport:{
        root: '/soluciones/valor-agregado-cat/servicio-y-soporte',
        preventiveMaintenanceAgreement: '/soluciones/valor-agregado-cat/servicio-y-soporte/acuerdo-de-mantenimiento-preventivo',
        extendedCoverCat: '/soluciones/valor-agregado-cat/servicio-y-soporte/cobertura-extendida-cat',
        serviceCommitment: '/soluciones/valor-agregado-cat/servicio-y-soporte/compromiso-de-servicios',
        guaranteedFuelProgram: '/soluciones/valor-agregado-cat/servicio-y-soporte/programa-de-combustible-garantizado',
      },
      financialSolutions:{
        root: '/soluciones/valor-agregado-cat/cuenta-comercial-cat',
        accountComertialCat: '/soluciones/valor-agregado-cat/cuenta-comercial-cat',
      }
    }
  },
  external: {
    constructionTechnology: 'https://www.sitechnoroeste.com.mx/',
    googlePlayStore: 'https://play.google.com/store/apps/details?id=com.cat.digital.mobile.sis2go&hl=es',
    appleStore: 'https://apps.apple.com/es/app/cat-sis2go/id1528609895',
    microsoftStore: 'https://apps.microsoft.com/detail/9n6svzr1lfvc?hl=es-mx&gl=MX',
    visionLink: 'https://vl.cat.com/es-ES',
    si2go: 'https://sis2.cat.com/#',
    partsMatco: 'https://parts.cat.com/es/matco',
    mycatFinancial: 'https://mycatfinancial.com/s/apply?language=es_MX',
    usedParts: 'https://parts.cat.com/es/matco',
    discounts: 'https://www.cat.com/es_MX/promotions/finance/commercial-account.html',
    credits: 'https://www.cat.com/es_MX/support/cat-credits.html',
    loginFinancial: 'https://mycatfinancial.com/GC_Login?ec=302&startURL=%2Fs%2F',
    solicitude: 'https://mycatfinancial.com/s/apply?language=es_MX',
    naturalPerson: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20260218-443b0-4f2f7',
    moralPerson: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20260218-62df8-069da',
    anex: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20260218-0e3cf-2fe4b',
    formationBC: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20260218-12e7c-83e2a',
    formationGeneralData: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20260218-82d56-0fe1d',
    termsCat: 'https://s7d2.scene7.com/is/content/Caterpillar/CM20260218-2f696-0646f',
    rulesRewards: 'https://www.cat.com/reglasderecompensas',
    catRewards: 'https://www.cat.com/es_MX/support/cat-rewards.html',
    register: 'https://register.cat.com/?p=register&clientId=23f1628f-fa51-4612-ad8f-48931ed4b70f&ui_locales=es&redirect_uri=https%3A%2F%2Fvl.cat.com%3FisReRequest%3Dtrue'
  }
} as const
